import "./Help.scss";
import ActionBar from "../../components/ActionBar/ActionBar";
import ActionBarButton from "../../components/ActionBar/ActionBarButton";
import "../../components/ActionBar/ActionBarButton.scss";
import "../../components/ActionBar/ActionBar.scss";
import BrandTitle from "../../components/BrandTitle/BrandTitle";
import { Trans, useTranslation } from "react-i18next";

// Shared <Trans> components for the help text
const TEXT = {
  strong: <strong />,
  badge: <span className="admin-badge" />,
  icon: <span className="inline-icon material-symbols-outlined" />,
};

function Help() {
  const { t } = useTranslation();
  return (
    <div className="help-wrapper">
      {/* <ActionBar>
        <ActionBarButton
          text="Documentation"
          iconName="menu_book"
        />
        <ActionBarButton
          text="Support"
          iconName="support_agent"
        />
      </ActionBar> */}

      <div className="help">
        <div className="help-content">
          <div className="help-header">
            <h1>
              <img
                src="/somigo_logo.svg"
                alt={t("help.logoAlt")}
                className="help-logo"
              />
              <Trans
                i18nKey="help.welcome"
                components={{ brand: <BrandTitle fontSize={32} /> }}
              />
            </h1>
            <p className="help-subtitle">
              <Trans
                i18nKey="help.subtitle"
                components={{ brand: <BrandTitle fontSize={16} /> }}
              />
            </p>
          </div>

          {/* First Time Visitor Section */}
          <div className="first-time-banner">
            <div className="first-time-content">
              <span className="material-symbols-outlined wave-icon">
                waving_hand
              </span>
              <div className="first-time-text">
                <h3>{t("help.firstTime.title")}</h3>
                <p>
                  <Trans i18nKey="help.firstTime.body" components={TEXT} />
                </p>
              </div>
            </div>
          </div>

          {/* Getting Started Video Section */}
          <div className="help-video-section">
            <div className="video-header">
              <span className="material-symbols-outlined">play_circle</span>
              <h2>{t("help.video.title")}</h2>
            </div>
            <p className="video-subtitle">{t("help.video.subtitle")}</p>
            <div className="help-video-wrapper">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/U1tFGdum8nk"
                title={t("help.video.iframeTitle")}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>

          {/* Getting Started Section */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">rocket_launch</span>
              <h2>{t("help.gettingStarted.title")}</h2>
            </div>

            {/* Joined Organization Info */}
            <div className="help-card info-card">
              <div className="card-content full-width">
                <div className="info-banner">
                  <span className="material-symbols-outlined">mail</span>
                  <div>
                    <h4>{t("help.gettingStarted.noProjects.title")}</h4>
                    <p>{t("help.gettingStarted.noProjects.body")}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Admin Role Info */}
            <div className="help-card info-card">
              <div className="card-content full-width">
                <div className="info-banner">
                  <span className="material-symbols-outlined">info</span>
                  <div>
                    <h4>{t("help.gettingStarted.adminInfo.title")}</h4>
                    <p>
                      <Trans
                        i18nKey="help.gettingStarted.adminInfo.body"
                        components={TEXT}
                      />
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="help-card">
              <div className="card-icon">
                <span className="material-symbols-outlined">domain</span>
              </div>
              <div className="card-content">
                <h3>{t("help.gettingStarted.organization.title")}</h3>
                <p>{t("help.gettingStarted.organization.body")}</p>
                <ul>
                  <li>
                    <Trans
                      i18nKey="help.gettingStarted.organization.items.open"
                      components={TEXT}
                    />
                  </li>
                  <li>{t("help.gettingStarted.organization.items.create")}</li>
                  <li>
                    <Trans
                      i18nKey="help.gettingStarted.organization.items.edit"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.gettingStarted.organization.items.invite"
                      components={TEXT}
                    />
                  </li>
                </ul>
              </div>
            </div>

            <div className="help-card">
              <div className="card-icon">
                <span className="material-symbols-outlined">folder_copy</span>
              </div>
              <div className="card-content">
                <h3>
                  {t("help.gettingStarted.project.title")}{" "}
                  <span className="admin-badge">{t("help.adminOnly")}</span>
                </h3>
                <p>{t("help.gettingStarted.project.body")}</p>
                <ul>
                  <li>
                    <Trans
                      i18nKey="help.gettingStarted.project.items.open"
                      components={TEXT}
                    />
                  </li>
                  <li>{t("help.gettingStarted.project.items.create")}</li>
                  <li>{t("help.gettingStarted.project.items.name")}</li>
                  <li>{t("help.gettingStarted.project.items.assign")}</li>
                  <li>{t("help.gettingStarted.project.items.edit")}</li>
                </ul>
              </div>
            </div>

            <div className="help-card">
              <div className="card-icon">
                <span className="material-symbols-outlined">
                  assignment_turned_in
                </span>
              </div>
              <div className="card-content">
                <h3>{t("help.gettingStarted.tasks.title")}</h3>
                <p>{t("help.gettingStarted.tasks.body")}</p>
                <ul>
                  <li>
                    <Trans
                      i18nKey="help.gettingStarted.tasks.items.navigate"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.gettingStarted.tasks.items.actionBar"
                      components={TEXT}
                    />
                  </li>
                  <li>{t("help.gettingStarted.tasks.items.describe")}</li>
                  <li>
                    <Trans
                      i18nKey="help.gettingStarted.tasks.items.notes"
                      components={TEXT}
                    />
                  </li>
                </ul>
              </div>
            </div>

            <div className="help-card">
              <div className="card-icon">
                <span className="material-symbols-outlined">dashboard</span>
              </div>
              <div className="card-content">
                <h3>
                  {t("help.gettingStarted.dashboard.title")}{" "}
                  <span className="admin-badge">{t("help.adminOnly")}</span>
                </h3>
                <p>{t("help.gettingStarted.dashboard.body")}</p>
                <ul>
                  <li>
                    <Trans
                      i18nKey="help.gettingStarted.dashboard.items.navigate"
                      components={TEXT}
                    />
                  </li>
                  <li>{t("help.gettingStarted.dashboard.items.stats")}</li>
                  <li>{t("help.gettingStarted.dashboard.items.monitor")}</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Top Bar Guide */}
          <section className="help-section">
            <div className="section-header">
              <h2>{t("help.topBar.title")}</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <p>{t("help.topBar.intro")}</p>
                <div className="feature-grid">
                  <div className="feature-item">
                    <span className="material-symbols-outlined">domain</span>
                    <h4>{t("help.topBar.organizations.title")}</h4>
                    <p>{t("help.topBar.organizations.body")}</p>
                  </div>
                  <div className="feature-item">
                    <span className="material-symbols-outlined">group</span>
                    <h4>
                      {t("topBar.peopleAndTeams")}{" "}
                      <span className="admin-badge-small">
                        {t("common.admin")}
                      </span>
                    </h4>
                    <p>{t("help.topBar.people.body")}</p>
                  </div>
                  <div className="feature-item">
                    <span className="material-symbols-outlined">
                      folder_copy
                    </span>
                    <h4>{t("organizations.projectsLabel")}</h4>
                    <p>{t("help.topBar.projects.body")}</p>
                  </div>
                  <div className="feature-item">
                    <span className="material-symbols-outlined">
                      manage_accounts
                    </span>
                    <h4>{t("userMenu.userSettings")}</h4>
                    <p>{t("help.topBar.userSettings.body")}</p>
                  </div>
                </div>
                <div className="info-box" style={{ marginTop: "20px" }}>
                  <span className="material-symbols-outlined">info</span>
                  <p>
                    <Trans i18nKey="help.topBar.context" components={TEXT} />
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Managing Projects */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">settings</span>
              <h2>{t("help.managingProjects.title")}</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <h3>{t("help.managingProjects.features")}</h3>
                <div className="features-list">
                  <div className="feature-detail">
                    <span className="material-symbols-outlined">palette</span>
                    <div>
                      <h4>{t("help.managingProjects.color.title")}</h4>
                      <p>{t("help.managingProjects.color.body")}</p>
                    </div>
                  </div>
                  <div className="feature-detail">
                    <span className="material-symbols-outlined">group_add</span>
                    <div>
                      <h4>
                        {t("help.managingProjects.team.title")}{" "}
                        <span className="admin-badge-small">
                          {t("common.admin")}
                        </span>
                      </h4>
                      <p>{t("help.managingProjects.team.body")}</p>
                    </div>
                  </div>
                  <div className="feature-detail">
                    <span className="material-symbols-outlined">edit</span>
                    <div>
                      <h4>
                        {t("help.managingProjects.settings.title")}{" "}
                        <span className="admin-badge-small">
                          {t("common.admin")}
                        </span>
                      </h4>
                      <p>{t("help.managingProjects.settings.body")}</p>
                    </div>
                  </div>
                  <div className="feature-detail">
                    <span className="material-symbols-outlined">
                      swap_horiz
                    </span>
                    <div>
                      <h4>{t("help.managingProjects.switching.title")}</h4>
                      <p>{t("help.managingProjects.switching.body")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Tasks and Notes */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">task_alt</span>
              <h2>{t("help.tasksNotes.title")}</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <h3>{t("help.tasksNotes.tasks.title")}</h3>
                <p>{t("help.tasksNotes.tasks.intro")}</p>
                <ul className="styled-list">
                  <li>
                    <Trans
                      i18nKey="help.tasksNotes.tasks.items.sections"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.tasksNotes.tasks.items.assignments"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.tasksNotes.tasks.items.status"
                      components={TEXT}
                    />
                  </li>
                </ul>

                <h3>{t("help.tasksNotes.notes.title")}</h3>
                <p>{t("help.tasksNotes.notes.intro")}</p>
                <ul className="styled-list">
                  <li>
                    <Trans
                      i18nKey="help.tasksNotes.notes.items.richText"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.tasksNotes.notes.items.groups"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.tasksNotes.notes.items.collaboration"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.tasksNotes.notes.items.search"
                      components={TEXT}
                    />
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Post-Its */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">note_stack</span>
              <h2>{t("help.postIts.title")}</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <h3>{t("help.postIts.subtitle")}</h3>
                <p>{t("help.postIts.intro")}</p>
                <ul className="styled-list">
                  <li>
                    <Trans
                      i18nKey="help.postIts.items.access"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.postIts.items.create"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.postIts.items.drag"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.postIts.items.edit"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.postIts.items.colors"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans i18nKey="help.postIts.items.pin" components={TEXT} />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.postIts.items.front"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.postIts.items.delete"
                      components={TEXT}
                    />
                  </li>
                </ul>
                <p className="tip">
                  <Trans i18nKey="help.postIts.tip" components={TEXT} />
                </p>
              </div>
            </div>
          </section>

          {/* Checklists */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">checklist</span>
              <h2>{t("help.checklists.title")}</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <h3>{t("help.checklists.subtitle")}</h3>
                <p>{t("help.checklists.intro")}</p>
                <ul className="styled-list">
                  <li>
                    <Trans
                      i18nKey="help.checklists.items.access"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.checklists.items.create"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.checklists.items.add"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.checklists.items.reorder"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.checklists.items.templates"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.checklists.items.useTemplates"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.checklists.items.search"
                      components={TEXT}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.checklists.items.progress"
                      components={TEXT}
                    />
                  </li>
                </ul>
                <p className="tip">
                  <Trans i18nKey="help.checklists.tip" components={TEXT} />
                </p>
              </div>
            </div>
          </section>

          {/* Chat Feature */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">chat</span>
              <h2>{t("help.chat.title")}</h2>
            </div>
            <div className="help-card">
              <div className="card-content full-width">
                <h3>{t("help.chat.subtitle")}</h3>
                <p>{t("help.chat.intro")}</p>
                <ul className="styled-list">
                  <li>
                    <Trans i18nKey="help.chat.items.access" components={TEXT} />
                  </li>
                  <li>
                    <Trans i18nKey="help.chat.items.direct" components={TEXT} />
                  </li>
                  <li>
                    <Trans i18nKey="help.chat.items.teams" components={TEXT} />
                  </li>
                  <li>
                    <Trans
                      i18nKey="help.chat.items.realtime"
                      components={TEXT}
                    />
                  </li>
                </ul>
                <div className="info-box" style={{ marginTop: "20px" }}>
                  <span className="material-symbols-outlined">info</span>
                  <p>
                    <Trans i18nKey="help.chat.note" components={TEXT} />
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Tips and Best Practices */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">lightbulb</span>
              <h2>{t("help.tips.title")}</h2>
            </div>
            <div className="help-card tips-card">
              <div className="card-content full-width">
                <div className="tips-grid">
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>{t("help.tips.items.structure")}</p>
                  </div>
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>{t("help.tips.items.names")}</p>
                  </div>
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>{t("help.tips.items.statuses")}</p>
                  </div>
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>{t("help.tips.items.sections")}</p>
                  </div>
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>{t("help.tips.items.notes")}</p>
                  </div>
                  <div className="tip-item">
                    <span className="material-symbols-outlined">
                      check_circle
                    </span>
                    <p>{t("help.tips.items.roles")}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Need More Help */}
          <section className="help-section">
            <div className="section-header">
              <span className="material-symbols-outlined">support</span>
              <h2>{t("help.contact.title")}</h2>
            </div>
            <div className="help-card contact-card">
              <div className="card-content full-width">
                <p>{t("help.contact.intro")}</p>
                <div className="contact-options">
                  <div className="contact-option">
                    <span className="material-symbols-outlined">email</span>
                    <div>
                      <h4>{t("help.contact.email")}</h4>
                      <p>contact@somigo.io</p>
                    </div>
                  </div>
                  <div className="contact-option">
                    <span className="material-symbols-outlined">
                      bug_report
                    </span>
                    <div>
                      <h4>{t("help.contact.bug.title")}</h4>
                      <p>{t("help.contact.bug.body")}</p>
                    </div>
                  </div>
                  <div className="contact-option">
                    <span className="material-symbols-outlined">lightbulb</span>
                    <div>
                      <h4>{t("help.contact.feature.title")}</h4>
                      <p>{t("help.contact.feature.body")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Help;
